export const questionTypeUiSchema = t => {
  return {
    isMandatory: {
      "ui:widget": "toggle",
    },
    isActive: {
      "ui:widget": "toggle",
      "ui:options": {
        labels: [
          { label: t("ACTIVE"), value: true },
          { label: t("INACTIVE"), value: false },
        ],
      },
    },
    consentToShare: {
      "ui:widget": "toggle",
    },
    startNotification: {
      "ui:widget": "hidden",
    },
    updateNotification: {
      "ui:widget": "toggle",
    },
    closeNotification: {
      "ui:widget": "toggle",
    },
    questionText: {
      "ui:widget": "text",
    },
    advisorType: {
      "ui:widget": "hidden",
    },
  };
};

export const lengthScopeUiSchema = {
  durationDays: {
    "ui:widget": "number-input",
  },
};
